import { Height } from '@mui/icons-material';

export const UpgradeAgencyPlanModalSxs = {
  titleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)',
    marginTop: '10px'
  },
  billingCycle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-text-dark)',
    marginBottom: '10px'
  },
  billingBox: {
    marginTop: '34px'
  },
  timelineBoxSx: {
    position: 'relative',
    padding: '12px 18px 12px 18px',
    borderRadius: '6px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer'
  },
  timelineBoxTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    color: 'var(--color-primary)'
  },
  timelineBoxTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)',
    marginBottom: '5px'
  },
  spanAmountSx: {
    fontSize: 'var(--font-size-24)',
    fontWeight: 700
  },
  spanCheckedAmount: {
    color: 'var(--color-text-purple)',
    textDecoration: 'line-through'
  },
  discountSpan: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)'
  },
  discountBox: {
    padding: '4px',
    paddingTop: '0px',
    paddingBottom: '1px',
    borderRadius: '32px',
    background: 'var(--color-success-bg)',
    width: 'fit-content'
  },
  typoBoxSx: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'baseline', sm: 'center' },
    gap: '8px'
  },
  loadingBoxSx: {
    width: '100%',
    height: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mainContainerSx: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', ms: 'row' }
  },
  alertSx: {
    mb: 1
  },
  firstContainerSx: {
    padding: '26px'
  },
  secondContainerSx: {
    width: { xs: '100%', ms: '40%' },
    background: 'var(--color-bg-muted-alt)',
    padding: '26px'
  },
  joiDescSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-primary)'
  },
  joiBoxSx: {
    display: 'flex',
    gap: '8px',
    marginTop: '3px',
    alignItems: 'center'
  },
  iconBtnSx: {
    marginTop: { xs: '0px', ms: '-20px' },
    color: 'var(--color-text-sidebar-icon)'
  },
  avatarGroupBoxSx: {
    display: 'flex',
    marginTop: '8px'
  },
  listTitleSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  listBoxSx: {
    marginTop: '32px'
  },
  listSubBoxSx: {
    marginTop: '8px'
  },
  listFeatureBoxSx: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    marginBottom: '12px'
  },
  listFeatureTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  learnMoreSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    textDecoration: 'underline',
    color: 'var(--color-success-dark)',
    cursor: 'pointer'
  },
  learnMoreBoxSx: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: '22px'
  },
  greenUpImgStyle: {
    cursor: 'pointer'
  },
  titleBoxSx: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  absoluteTextSx:{
    position: 'absolute',
    top: '-14px',
    right: '12px',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-primary)',
    borderRadius: '32px',
    px:'10px',
    paddingBottom: '3px'
  }
};
